import React from "react";
import CustomTable from "../../components/CustomTable";
import { getProjectCounts, getProjects } from "../../../store/actions/ProjectActions";
import CountIcon from "./../../../images/CountIcon.svg";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { getStatusColor, getStatusStyles } from "../../../utils/functions/date";
import { projectStatusOptions } from "../../../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import ProjectFilterComponent from "./ProjectFilterComponent";
import { projectValidationSchema } from "../../../utils/validationSchemas/MasterDataSchema";
import EditProject from "./forms/EditProject";

function getAgeFromDob(dob) {
  if (!dob) return null;

  const birthDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();

  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();

  // Adjust if birthday hasn't occurred yet this year
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
}

function formatGender(gender) {
  if (!gender) return "-";

  // Check if gender is "Prefer Not to Share" (case-insensitive)
  if (gender.toLowerCase() === "prefer not to share") {
    return "Not Sharing";
  }

  // Capitalize first letter
  return gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase();
}

const Projects = () => {
  const dispatch = useDispatch();
  const { projectCounts } = useSelector((state) => state.projects);

  const refreshPage = (data) => {
    return (dispatch) => {
      dispatch(getProjects(data));
      dispatch(getProjectCounts());
    };
  };
  const columns = [
    {
      label: "#",
      render: (row) => <span>{row?.projectCode ?? "-"}</span>,
    },
    {
      label: "Project",
      render: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-bold">{row?.conceptTitle ?? "-"}</span>
          <span className="text-muted small">{row?.artForm?.name ?? "-"} {row?.artForm?.name && row?.genre?.name ? `| ${row?.genre?.name}` : null} </span>
        </div>
      ),
    },
    {
      label: "Artist",
      render: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-bold">{`${row?.artist?.firstName} ${row?.artist?.lastName}`}</span>
          <span className="text-muted small">
            {`${row?.artist?.countryCode.includes("+") ? row?.artist?.countryCode : `+${row?.artist?.countryCode}`} ${row?.artist?.mobileNumber}`}
          </span>
        </div>
      ),
    },
    {
      label: "Profile",
      render: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-bold">{row?.artist?.city?.name ?? "-"}</span>
          <span className="text-muted small">
            {getAgeFromDob(row?.artist?.dob)}, {formatGender(row?.artist?.gender)}
          </span>
        </div>
      ),
    },
    {
      label: "Role",
      render: (row) => <span>{`${row?.ArtistProject?.filter(x => x.artist == row?.artist?._id)[0]?.role ?? "-"}`}</span>,
    },
    {
      label: "Stage",
      render: (row) => {
        const styles = getStatusStyles(row?.status);

        return (
          <span
            className="px-1 py-2"
            style={{
              ...styles,
              borderRadius: "4px",
            }}
          >{`${row?.status ?? "-"}`}</span>
        );
      },
    },
  ];

  const navigate = useNavigate();
  const modalConfig = {
    initialValues: {
      _id: "",
      conceptTitle: "",
      duration: "",
      role: "",
      conceptNote: "",
      artForm: "",
      genre: "",
      previouslyShowcased: "",
      supportingMaterialPdf: "",
    },
    validationSchema: projectValidationSchema,
    apiUrl: "projects/update-details/",
    FormComponent: EditProject,
    addTitle: "Add Project",
    updateTitle: "Update Project",
    extraProps: {
      relationKeys: ["artForm", "genre"],
    },
  };

  return (
    <div className="container-mxw">
      <div className="d-flex align-items-center mb-4 gap-4">
        {[
          {
            artForm: "Applicants",
            count: projectCounts?.totalApplications[0]?.total || 0
          },
          ...projectCounts.topArtForms
        ].map((item, index) => (
          <div
            key={index}
            className="d-flex align-items-center gap-3 count-box w-100"
          >
            <div className="align-self-start">
              <img src={CountIcon} />
            </div>
            <div>
              <h3>{item.artForm}</h3>
              <h4>{item.count}</h4>
            </div>
          </div>
        ))}
      </div>

      <CustomTable
        columns={columns}
        title="Projects"
        getHook={refreshPage}
        store={"projects"}
        search={true}
        addBtnTitle={false}
        filterIcon={true}
        FilterComponent={ProjectFilterComponent}
        onRowClick={(id, data) => {
          if (data?.status == "Showcase") {
            navigate(`/projects/${id}/showcase`);
          } else {
            navigate(`/projects/${id}`);
          }
        }}
        deleteHook={"projects"}
        isEdit={true}
        formModal={true}
        modalConfig={modalConfig}
        importData={"upload-projects"}
      />
    </div>
  );
};

export default Projects;
